import { useEffect, useState } from "react";
import MedicalFitnessStatusResult from "./MedicalFitnessStatusResult";
import { getMedicalFitnessStatus } from "../../services/rhapsody/MedicalFitness";
import { fetchTranslationData } from "../../services/translation/translation";
import { ServiceTranslation } from "../../utils/constants";
import DatePicker from "react-datepicker";
import { configureFirstIframe, getCurrentLocale, getLayoutDirection, isMobileApp } from "../../utils/util";

function convert(str) {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
}

const MedicalFitnessCheckDashboard = () => {
  const [referenceNo, setReferenceNo] = useState("");
  const [dob, setDob] = useState("");
  const [message, setMessage] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [result, setResult] = useState(false);
  const [applicationStatus, setApplicationStatus] = useState("");
  const [translationMap, setTranslationMap] = useState(null);
  const [isMobile, setIsMobile] = useState(false);


  const handleDateChange = (date) => {
    if (date) {
      setDob(date);
    } else {
      setDob("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!referenceNo && !dob) {
      setShowAlert(true);
      setMessage({ message: translationMap?.refNumError, heading: translationMap?.invalidRefNum });
      setResult(false);
      return;
    } else if (!referenceNo) {
      setShowAlert(true);
      setMessage({ message: translationMap?.refDateError, heading: translationMap?.invalidRefNum });
      setResult(false);
      return;
    } else if (referenceNo && !dob) {
      setShowAlert(true);
      setMessage({ message: translationMap?.dateInvalidError, heading: translationMap?.dateInvalid });
      setResult(false);
      return;
    }

    const isEligible = await checkEligibility(referenceNo, convert(dob));

    if (!isEligible) {
      setShowAlert(true);
      setMessage({ message: translationMap?.noRecordFound, heading: translationMap?.invalidInfo });
      setResult(false);
    } else {
      setShowAlert(false);
      setResult(true);
    }
    window.parent.scrollTo(0, 0);
  };

  //Fetch Translation
  useEffect(() => {
    configureFirstIframe(200, -600);

    fetchTranslationData(ServiceTranslation.MedicalFitness).then((result) => {
      setTranslationMap(result);
    });
    setIsMobile(isMobileApp());
  }, []);
  // Function to close alert box
  const closeAlert = () => {
    setShowAlert(false);
  };

  const handleBack = () => {
    setResult(false);
    setReferenceNo("");
    setDob("");
  };

  const checkEligibility = async (referenceNo, dob) => {
    try {
      const response = await getMedicalFitnessStatus(referenceNo, dob); // Send referenceNo and dob as parameters
      if (response.status === 200 && response.data !== null) {
        let local = getCurrentLocale();
        if (local === "ar" || local === "ar_SA") {
          setApplicationStatus(response.data?.ApplicationStatusAr);

        } else {
          setApplicationStatus(response.data?.ApplicationStatus);
        }
        return true;
      }
      return false;
    } catch (error) {
      console.error("Error fetching medical fitness status", error);
      return false;
    }
  };


  if (result) return <MedicalFitnessStatusResult
    refNo={referenceNo}
    status={applicationStatus}
    onBack={handleBack}
    translationMap={translationMap}
    isMobile={isMobile} />;


  return (
    <div className={` custombody_color ${getLayoutDirection()}`} id="sectionMedicalFitness">
            <section className="w-100 clearfix ManageDependentMainSection" id="CoverPlanActive">

                <div className="container customContainer">
                    {!isMobile &&
          <div className="Title_Inner_Box">
                            <h1 className="MainTitleOne"> {translationMap?.medicalFitnessStatusCheck}</h1>
                        </div>
          }
                    <div className="cover_inner_wrapper cover_inner_wrapper2">
                        <div className="cover_main_box1">
                            {showAlert &&
              <div
                className="AlertInnerBox AlertInnerBox2 YellowAlertInnerBox alert alert-dismissible fade show">
                                    <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  onClick={closeAlert}>
                  
                                        <span aria-hidden="true">
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17 7L7 17M7 7L17 17" stroke="#002F70" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                        </span>
                                    </button>
                                    <div className="Icon_box">
                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                        <a href="javascript:void(0);">
                                            <span className="material-symbols-outlined">warning</span>
                                        </a>
                                    </div>
                                    <div className="alert_text">
                                        <h6>
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">{message.heading} </a>
                                        </h6>
                                        <p className="number_txt">
                                            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url */}
                                            <a href="javascript:void(0);">
                                                {message.message}
                                            </a>
                                        </p>
                                    </div>
                                </div>
              }

                            {!result &&
              <div className="dependent_form_box">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form_inner_box">
                                            <div className="inner_input_box">
                                                <div className="input_box">
                                                    <label>{translationMap?.refNum}</label>
                                                    <div className="input_wrap">
                                                        <input
                            type="number"
                            value={referenceNo}
                            className="form-control"
                            id="referencenumber"
                            placeholder={translationMap?.refplaceHolder}
                            onChange={(e) => setReferenceNo(e.target.value)} />
                          
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="inner_input_box">
                                                <div className="input_box">
                                                    <label>{translationMap?.dob}</label>
                                                    <div className=" input-group input_wrap">

                                                        <DatePicker selected={dob}
                          placeholderText={translationMap?.dobPlaceHolder}
                          onChange={handleDateChange}
                          maxDate={new Date()}
                          className="date_input"
                          id="displayDateInput"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          onFocus={(e) => e.target.blur()} />
                          
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form_btn_box">
                                            <button type="submit" className="bluetrans_btn_link">
                                                {translationMap?.checkStatus}
                                            </button>
                                        </div>
                                    </form>
                                </div>
              }
                        </div>
                        <div className="cover_main_box2"></div>
                    </div>
                </div>
            </section>
        </div>);

};

export default MedicalFitnessCheckDashboard;